export default "__VITE_ASSET__24dcb680__"